import Banner from './Banner';
import Summary from './Summary';
import Price from './Price';
import Inventory from './Inventory';
import { useLayoutEffect, useState } from 'react';
import Condition from './Condition';
import { useParams, useSearchParams } from 'react-router-dom';

const ProductPage = () => {
  let { vin } = useParams();
  const [loading, setLoading] = useState(false);
  const [query]=useSearchParams();
  let isSalvage=query.get("isSalvage");
  useLayoutEffect(()=>{
    window.scroll(0,0)
  },[])
  return (
    <>
      <Banner />
      <Summary vin={vin} loading={loading} setLoading={setLoading}/>
      {/* <Condition vin={vin} setLoading={setLoading}/> */}
      {!JSON.parse(isSalvage) && <Price vin={vin} setLoading={setLoading}/>}
      <Inventory />
    </>
  );
};

export default ProductPage;
